import React from 'react';
import Home from './pages/home/Home';
import {HashRouter,Route} from 'react-router-dom';
import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';
import ProfileSettingsForm from './pages/settings/ProfileSettingsForm';
import Live from './pages/live/Live';
import DeclareActionPage from './pages/live/actions/declareaction/DeclareActionPage';
import DebutForm from './pages/live/actions/forms/debut/DebutForm';
import './index.css';
import But from './pages/live/actions/forms/but/But';
import Tir from './pages/live/actions/forms/tir/Tir';
import Cartons from './pages/live/actions/forms/cartons/Cartons';
import Onboarding from './pages/onboarding/Onboarding';
import { resetCaches } from './helpers';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { initializeConnexion } from './actions/connexionActions';
import PenaltyDeclarationPage from './pages/live/actions/forms/penalty/declaration/PenaltyDeclarationPage';
import PenaltyResultPage from './pages/live/actions/forms/penalty/result/PenaltyResultPage';
import SubstitutionFormPage from './pages/live/actions/forms/remplacement/SubstitutionFormPage';
import TirAuButFormPage from './pages/live/actions/forms/tab/TirAuButFormPage';
import LaunchAppPage from './pages/launch/LaunchAppPage';
import ConnexionPage from './pages/connexion/Connexion';

const App = props => {
  
  props.initializeConnexion();

  resetCaches();
  
  return (
    <HashRouter>
        <Route exact path={'/'} component={LaunchAppPage} />
        <Route exact path={'/connexion'} component={ConnexionPage} />
        <Route exact path={'/matches'} component={Home} />
        <Route exact path={['/subscribe/live/:maNo','/profile/settings']} component={ProfileSettingsForm} />
        <Route exact path='/live/:id' component={Live} />
        <Route exact path='/live/:id/actions/add' component={DeclareActionPage} />
        <Route exact path={['/live/:id/debut','/live/:id/prolongations']} component={DebutForm} />
        <Route exact path='/live/:id/but' component={But} />
        <Route exact path={['/live/:id/tir', '/live/:id/coup-de-pied-arrete']} component={Tir} />
        <Route exact path={['/live/:id/cartons', '/live/:id/carton-(.*)']} component={Cartons} />
        <Route exact path={'/onboarding/:maNo'} component={Onboarding} />
        <Route exact path={'/live/:id/penalty_declaration'} component={PenaltyDeclarationPage} />
        <Route exact path={['/live/:id/penalty_resultat', '/live/:id/penalty_resultat-(.*)']} component={PenaltyResultPage} />
        <Route exact path={['/live/:id/substitution', '/live/:id/remplacement']} component={SubstitutionFormPage} />
        <Route exact path={'/live/:id/tab'} component={TirAuButFormPage} />
    </HashRouter>
  );
}

const mapDispatchToProps = dispatch => bindActionCreators({ initializeConnexion }, dispatch);

export default connect(null, mapDispatchToProps)(App);
